import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import './StatPill.css';

const StatPill = forwardRef(({ items, className, style, ...rest }, ref) => (
    <div ref={ref} className={`statPill ${className || ''}`} style={style} {...rest}>
        {items.map((item, index) => (
            <div className="statPillItem" key={index}>
                <span className="statPillLabel">{item.label}</span>
                <span className="statPillValue">{item.value}</span>
            </div>
        ))}
    </div>
));

StatPill.displayName = 'StatPill';

StatPill.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.node,
        value: PropTypes.node,
    })).isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default StatPill;
